
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/laws",
      function () {
        return require("private-next-pages/[lang]/laws/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/laws"])
      });
    }
  